var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToolsSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.43891 3.49165L15.924 8.22495L11.5643 10.1656C10.9254 10.4416 10.4159 10.9492 10.1388 11.5856L8.20249 15.9284L3.4508 3.49165H3.43891ZM2.14411 1.125C1.9784 1.12542 1.81524 1.16597 1.66877 1.2432C1.5223 1.32042 1.39688 1.43197 1.30335 1.56824C1.20981 1.70451 1.1509 1.86141 1.1318 2.02539C1.1127 2.18936 1.13398 2.35549 1.19372 2.50947L7.13333 18.2122C7.2063 18.4075 7.33769 18.5758 7.50977 18.6943C7.68186 18.8128 7.88641 18.8758 8.09561 18.8749C8.29598 18.878 8.49261 18.821 8.65999 18.7113C8.82738 18.6015 8.95766 18.4441 9.03397 18.2595L11.7187 12.2601C11.8175 12.0249 12.0053 11.8378 12.2414 11.7394L18.276 9.0651C18.4599 8.98022 18.6147 8.84338 18.7211 8.67159C18.8275 8.4998 18.8808 8.30064 18.8745 8.09888C18.8682 7.89713 18.8024 7.70171 18.6854 7.53687C18.5684 7.37203 18.4054 7.24505 18.2166 7.17177L2.46473 1.25515C2.34333 1.20891 2.21463 1.18486 2.08466 1.18415L2.14411 1.125Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolsSearchIcon);
export default __webpack_public_path__ + "static/media/tools-search-icon.2a88cb1468bb98486818b9b52b75e713.svg";
export { ForwardRef as ReactComponent };